<div data-testid="company-page" class="p-4 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "organizational.company.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="company-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'company-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAdd()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="company-table"
      #advancedTable
      [dataSource]="companies()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="searchParams().page * searchParams().size"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
    <!-- Custom Template for date -->
    <ng-template
      #customTemplate
      let-value
      let-rowData="rowData"
      let-column="column"
    >
      @if (column && column.template === "dateTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status let-rowData="rowData">
      <div class="flex items-center justify-center gap-1">
        <p-tag
          [attr.data-testid]="'company-status-tag-' + rowData.id"
          [value]="getStatusDisplayText(rowData.status)"
          [severity]="getStatusSeverity(rowData.status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(rowData.status)"
          [pTooltip]="getStatusDisplayText(rowData.status)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="actions-container flex gap-2 justify-center">
        @if (canRead()) {
          <app-button
            [testId]="'company-action-view-' + rowData.id"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }
        @if (canUpdate()) {
          <app-button
            [testId]="'company-action-edit-' + rowData.id"
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        }
        @if (canApprove()) {
          <app-button
            [testId]="
              'company-action-' +
              (rowData.status === 'ACTIVE' ? 'deactivate' : 'activate') +
              '-' +
              rowData.id
            "
            [class]="
              rowData.status === 'ACTIVE' ? 'action-disable' : 'action-enable'
            "
            [label]="
              rowData.status === 'ACTIVE'
                ? ('common.table.actions.deactivate' | translate)
                : ('common.table.actions.activate' | translate)
            "
            type="action"
            (emitOnClick)="
              onStatusChange(
                rowData,
                rowData.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
              )
            "
          ></app-button>
        }
        @if (canDelete()) {
          <app-button
            [testId]="'company-action-delete-' + rowData.id"
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            [disabled]="rowData.status === 'ACTIVE'"
            [tooltip]="
              rowData.status === 'ACTIVE'
                ? ('organizational.company.messages.error.cannot_delete_active'
                  | translate)
                : ''
            "
            tooltipPosition="top"
            [showDelay]="300"
            (emitOnClick)="onDelete(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="company-toast"></p-toast>
<p-toast data-testid="company-loading-toast" [key]="'company-loading'"></p-toast>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  data-testid="company-confirmation-dialog"
  [(visible)]="showConfirmationDialog"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
